/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import dayjs from 'dayjs';

export const formatAgreementDates = (startDate: Date, endDate: Date) => {
  const format = dayjs(startDate).year() === dayjs(endDate).year() ? 'D MMM' : 'D MMM YYYY';
  return `${dayjs(startDate).format(format)} - ${dayjs(endDate).format('D MMM YYYY')}`;
};
